import { useRef } from 'react';
import ReactDOM from 'react-dom';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import useDidMount from 'app/hook/common/useDidMount';

function ModalPortal({ children, bodyLockOption = {
		useBodyLock: false,
		innerScrollArea: '',
	} }) {
	const modalRef = useRef(document.getElementById('modal'));

	useDidMount(() => {
		const { useBodyLock, innerScrollArea } = bodyLockOption;

		if (useBodyLock && modalRef.current) {
			const scrollOption = innerScrollArea ? { allowTouchMove: (el) => !!el?.closest(innerScrollArea) } : {};
			disableBodyScroll(modalRef.current, scrollOption);
			return () => clearAllBodyScrollLocks();
		}

		return null;
	});

	return ReactDOM.createPortal(children, document.getElementById('modal'));
}

export default ModalPortal;
